import { Ref, forwardRef } from "react"
import { Form, FormikProps } from "formik"
import { Formik } from "../../../../../../shared/components/forms/SchemaFormik"
import * as yup from "yup"
import { CreateUpdateLocation, CreateUpdateLocationFormValues, HistoryType } from "../locationsTypes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { CreateUpdateLocationFormContent } from "./CreateUpdateLocationFormContent"

type CreateUpdateLocationFormProps = Readonly<{
    initialValues?: CreateUpdateLocationFormValues | null
    history?: HistoryType
    onSubmit: (formData: CreateUpdateLocation) => void
}>
type FormikRef = Ref<FormikProps<CreateUpdateLocationFormValues>>

export const CreateUpdateLocationForm = forwardRef(
    ({ initialValues, history, onSubmit }: CreateUpdateLocationFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const defaultInitialValues = {
            name: "",
            isActive: true,
            address: {
                street: "",
                streetNumber: "",
                postalCode: "",
                city: "",
                countryCode: "DK",
            },
        }

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("create-or-edit-company-location-field-is-required")),
            address: yup.object({
                street: yup.string().required(l10n.getString("create-or-edit-company-location-field-is-required")),
                streetNumber: yup
                    .string()
                    .required(l10n.getString("create-or-edit-company-location-field-is-required")),
                postalCode: yup.string().required(l10n.getString("create-or-edit-company-location-field-is-required")),
                city: yup.string().required(l10n.getString("create-or-edit-company-location-field-is-required")),
            }),
        })

        function handleSubmit(values: CreateUpdateLocationFormValues) {
            const { shops, ...valuesWithoutShops } = values

            let modifyData: CreateUpdateLocation = {
                ...valuesWithoutShops,
            }

            if (shops) {
                modifyData = {
                    ...modifyData,
                    shops: shops.map((id) => ({ id })),
                }
            }
            onSubmit(modifyData)
        }

        return (
            <>
                <Formik<CreateUpdateLocationFormValues>
                    enableReinitialize
                    initialValues={initialValues ? initialValues : defaultInitialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={ref}
                >
                    <Form>
                        <CreateUpdateLocationFormContent history={history} />
                    </Form>
                </Formik>
            </>
        )
    },
)
